import styled from 'styled-components';
import tw from 'twin.macro';

type Sizes = 'medium' | 'small';

const VerticalDivide = styled.div<{ size?: Sizes }>`
  ${tw`w-px my-2 bg-gray-300`}

  ${({ size = 'medium' }) => {
    switch (size) {
      case 'small':
        return tw`h-3 my-0`;
      case 'medium':
        return tw`h-5`;
    }
  }}
`;

export { VerticalDivide };
